import { DEPTH_IN_FALLBACK, SELECTOR } from './constants';

/** 등장 모션의 길이와 곡선 */
export interface DepthInTiming {
  duration: number;
  easing: string;
}

/** 탭 고정에 필요한 세 요소 */
export interface PinParts {
  $wrap: HTMLElement;
  $seat: HTMLElement;
  $inner: HTMLElement;
}

/** CSS에 적힌 시간을 ms로 읽는다. '300ms'와 '0.3s' 둘 다 받는다 */
export const readMs = (value: string, fallback: number): number => {
  const num = parseFloat(value);
  if (Number.isNaN(num)) return fallback;
  return value.trim().endsWith('ms') ? num : num * 1000;
};

/** 요소들의 렌더 높이 합 */
export const sumHeight = (els: Element[]): number =>
  els.reduce((total, el) => total + el.getBoundingClientRect().height, 0);

/** 요소의 흐름상 높이. display:contents 등으로 clientHeight가 0이면 자식 높이를 합산한다 */
export const getFlowHeight = (el: Element | null | undefined): number => {
  if (!el) return 0;
  if (el.clientHeight) return el.clientHeight;

  return sumHeight(Array.from(el.children));
};

/** 탭 고정에 쓰는 세 요소를 찾는다. 하나라도 없으면 null */
export const queryPinParts = (): PinParts | null => {
  const $wrap = document.querySelector(SELECTOR.wrap);
  const $seat = $wrap?.querySelector(SELECTOR.seat);
  const $inner = $seat?.querySelector(SELECTOR.inner);

  if (
    !($wrap instanceof HTMLElement) ||
    !($seat instanceof HTMLElement) ||
    !($inner instanceof HTMLElement)
  ) {
    return null;
  }

  return { $wrap, $seat, $inner };
};

/** 등장 모션 값을 LpScrollStyle의 --depth-in-* 에서 읽는다 */
export const getDepthInTiming = (): DepthInTiming => {
  const $wrap = document.querySelector(SELECTOR.wrap);
  if (!$wrap) return DEPTH_IN_FALLBACK;

  const styles = getComputedStyle($wrap);

  return {
    duration: readMs(
      styles.getPropertyValue('--depth-in-duration'),
      DEPTH_IN_FALLBACK.duration
    ),
    easing:
      styles.getPropertyValue('--depth-in-easing').trim() ||
      DEPTH_IN_FALLBACK.easing,
  };
};
